import { render, staticRenderFns } from "./IntroducitonContent3.vue?vue&type=template&id=1f6ea840&scoped=true"
import script from "./IntroducitonContent3.vue?vue&type=script&lang=js"
export * from "./IntroducitonContent3.vue?vue&type=script&lang=js"
import style0 from "./IntroducitonContent3.vue?vue&type=style&index=0&id=1f6ea840&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1f6ea840",
  null
  
)

export default component.exports